import React from 'react';
import { Tag, TagLabel } from '@chakra-ui/react';

type ColorTagVariant = 'gray' | 'purple' | 'green' | 'green-dark';

type ColorTagProps = {
  variant?: ColorTagVariant;
  children: React.ReactNode;
};

// Custom tokens are defined in `src/assets/styles/theme/index.ts` under `colors.colorTag`.
const colorMap: Record<ColorTagVariant, { bg: string; text: string; border?: string }> = {
  gray: { bg: 'transparent', text: 'gray.600', border: 'gray.200' },
  purple: { bg: 'colorTag.purple.bg', text: 'colorTag.purple.text' },
  green: { bg: 'colorTag.green.bg', text: 'colorTag.green.text' },
  'green-dark': { bg: 'colorTag.greenDark.bg', text: 'colorTag.greenDark.text' },
};

export const ColorTag: React.FC<ColorTagProps> = ({ variant = 'purple', children }) => {
  const { bg, text, border } = colorMap[variant];

  return (
    <Tag size="sm" bg={bg} color={text} borderWidth={border ? '1px' : 0} borderColor={border} h="6">
      <TagLabel fontWeight="bold" display="inline-flex" alignItems="center" lineHeight="1">
        {children}
      </TagLabel>
    </Tag>
  );
};
